import { Box, IconDeals, IconVerifiedUser, InfoBlock, KeyUser, NoShrink } from './styled'

import { User } from 'modules/domain/user/types'
import { getPersonalNumberLabel } from 'modules/utils/numbers/formatPersonalNumber'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import APhone from 'views/ui/Phone/APhone'

type Props = {
  user: User
}

export const UserInfo: FC<Props> = ({ user }) => {
  const { t } = useTranslation(['user', 'common'])
  const { profile } = user
  const isVerifiedUser = profile?.is_verified
  const profileType = profile?.profile_type
  const hasShippedDeals = profile?.has_shipped_deals
  const isSignificant = profile?.is_significant
  const userPhone = user.phone
  const teamName = profile?.team?.name
  const userInn = profile?.inn ? <NoShrink>{`, ${getPersonalNumberLabel()}: ${profile.inn}`}</NoShrink> : ''
  const extraContacts = [user.email ?? null, teamName ?? null].filter(Boolean).join(', ')

  return (
    <InfoBlock>
      <Box>
        {profileType ? `${t(`profile_type.${profileType}`)}, ` : t('common:unknown')}
        <NoShrink>{profile?.full_name}</NoShrink>
        <NoShrink>
          {isSignificant && <KeyUser />}
          {isVerifiedUser && <IconVerifiedUser />}
          {hasShippedDeals && <IconDeals />}
        </NoShrink>
        {userInn}
      </Box>
      <Box>
        <APhone phone={userPhone} marginRight="10px" />
        {extraContacts}
      </Box>
    </InfoBlock>
  )
}
